import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as d, openBlock as l, normalizeClass as r, createStaticVNode as o } from "vue";
import { _ as h } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const n = {
  name: "DtIconGiphy",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, s = ["aria-label", "data-qa", "aria-hidden"], p = /* @__PURE__ */ o('<path fill-rule="evenodd" clip-rule="evenodd" d="M4 2.667h8v10.666H4V2.667Z" fill="currentColor"></path><path d="M2 2h2v12H2V2Z" fill="#04FF8E"></path><path d="M12 5.333h2V14h-2V5.333Z" fill="#8E2EFF"></path><path d="M2 13.333h12v2H2v-2Z" fill="#00C5FF"></path><path d="M2 .667h6.667v2H2v-2Z" fill="#FFF152"></path><path d="M12.223 4.222V2.445h-1.779V.667H8.667V6H14V4.222" fill="#FF5B5B"></path><path d="M12 7.333V6h2" fill="#551C99"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M8.667.667v2H7.333" fill="#999131"></path>', 8), c = [
  p
];
function f(e, _, i, u, m, a) {
  return l(), d("svg", {
    "aria-label": i.ariaLabel,
    class: r([a.iconSizeClass, "d-icon d-icon--giphy"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Giphy",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, c, 10, s);
}
const H = /* @__PURE__ */ h(n, [["render", f]]);
export {
  H as default
};
//# sourceMappingURL=giphy.js.map
